import { render, staticRenderFns } from "./ExciseDORLicReturns.vue?vue&type=template&id=99775c18&scoped=true&"
import script from "./ExciseDORLicReturns.vue?vue&type=script&lang=js&"
export * from "./ExciseDORLicReturns.vue?vue&type=script&lang=js&"
import style0 from "./ExciseDORLicReturns.vue?vue&type=style&index=0&id=99775c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99775c18",
  null
  
)

export default component.exports